import { ArtikkelData } from 'types/content-props/artikkel-props';

export const artikkelDataMock: ArtikkelData = {
    ingress: '',
    text: { processedHtml: '', macros: [] },
    hasTableOfContents: 'none',
    fact: { processedHtml: '', macros: [] },
};
